/**
 * Normalises the paginated /lines-of-business list body to select options.
 */
export function linesOfBusinessFromApiResponse(
  body: { data?: { id: number; name: string }[] } | null | undefined
): { id: number; name: string }[] {
  const rows = body?.data;
  if (!Array.isArray(rows)) return [];
  return rows.map((row) => ({ id: row.id, name: row.name }));
}
